import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from 'antd';
import { IconButton, Tooltip } from '../Ant';
import { Notification } from '../icons';
import NotificationPopover from '../notificationPopover/notificationPopover';

interface NotificationBellButtonProps {
  notificationBadgeCount: number | string;
}

/** The bell stays mounted while the popover opens around it, so focus has somewhere to return to. */
const NotificationBellButton = ({ notificationBadgeCount }: NotificationBellButtonProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const className = [
    'notification-btn',
    isOpen && 'page-active',
    notificationBadgeCount !== 0 && 'has-notification',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <NotificationPopover isOpen={isOpen} onOpenChange={setIsOpen} onClose={() => setIsOpen(false)}>
      <Badge count={isOpen ? 0 : notificationBadgeCount} offset={[-7, 7]}>
        <Tooltip title={t('common:notifications')} placement="top" arrow={false}>
          <IconButton
            icon={<Notification />}
            size="large"
            data-testid="notification-button"
            aria-label={t('common:notifications')}
            aria-haspopup="dialog"
            aria-expanded={isOpen}
            className={className}
          />
        </Tooltip>
      </Badge>
    </NotificationPopover>
  );
};

export default NotificationBellButton;
